import script from "./Operation.vue?vue&type=script&setup=true&lang=js"
export * from "./Operation.vue?vue&type=script&setup=true&lang=js"

import "./Operation.vue?vue&type=style&index=0&id=7b7ce7e1&lang=scss&scoped=true"

import exportComponent from "C:\\IdeaWork\\Dweb2024\\platform-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7ce7e1"]])

export default __exports__